import swal from 'sweetalert';

export const DeleteDialog = (title, text) => {
  return swal({
    title: title,
    text: text,
    icon: 'warning',
    buttons: true,
    dangerMode: true,
  })
};

